import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  CardMedia,
  Box,  
} from '@mui/material';
import Footer from '../navbar/Footer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import { useNavigate } from 'react-router-dom'; 


const notesConjonctureData = [
    {
    title: "Note de conjoncture du Burundi, troisième trimestre 2025",
    link: "/documents/Bulletins/Note_conjoncture_T3_2025.pdf",
    date: new Date("2025-7-01"),
    description: "Une hausse de la production de l’Or au cours du troisième trimestre 2025 en glissement trimestriel (7,7%) et une hausse surprenante en glissement annuel (5231,5%)",
    image: "assets/Bulletins/notr_conj_2024_3tri.PNG",
  },
   {
    title: "Note de conjoncture du Burundi, deuxième trimestre 2025",
    link: "/documents/Bulletins/Note_conjoncture_T2_2025.pdf",
    date: new Date("2025-7-01"),
    description: "Au 2ᵉ trimestre 2025, les exportations bondissent de 95,4 % sur un trimestre et de 164,7 % sur un an, tandis que le déficit commercial se réduit à -610,6 contre -699,9 milliards BIF au 1ᵉʳ trimestre.",
    image: "assets/Bulletins/notr_conj_2024_3tri.PNG",
  },
  {
    title: "Note de conjoncture du Burundi, troisième trimestre 2024",
    link: "/documents/Bulletins/Note-de-conjoncture_T3-2024.pdf",
    date: new Date("2024-12-01"),
    description: "Une hausse de la production du wolframite au cours du 3ième trimestre 2024 en glissement trimestriel (31,0%) et baisse en glissement annuel (57,1%)",
    image: "assets/Bulletins/notr_conj_2024_3tri.PNG",
  },
  {
    title: "Note de conjoncture du Burundi, deuxième trimestre 2024",
    link: "/documents/Bulletins/Note-de-conjoncture_T2-2024.pdf",
    date: new Date("2024-09-01"),
    description: "Une dépréciation de la monnaie burundaise par rapport au dollar américain au cours du trimestre sous analyse de 13,3% en glissement annuel.",
    image: "assets/Bulletins/notr_conj_2024_2tri.PNG",
  },
  /*
  {
      title: "Note de conjoncture du Burundi, quatrième trimestre 2023",
      link: "/documents/Bulletins/Note-de-conjoncture_T4-2023.pdf",
      date: new Date("2023-12-30"),
      description: "Au quatrième trimestre 2023, le franc burundais a enregistré une dépréciation par rapport au dollar américain de 38,6 % en glissement annuel. Le taux de change pour un dollar au cours de ce trimestre s’est établi à 2 849,5 Fbu, contre 2 835,0 Fbu le trimestre précédent et 2 055,9 Fbu au même trimestre l'année dernière. La dépréciation trimestrielle s’élève à 0,5 %, tandis que la dépréciation totale pour l’année atteint 38,6 %. En revanche, la monnaie burundaise a légèrement augmenté face à l’euro, affichant une progression de 0,6 % en glissement trimestriel par rapport à une dépréciation de 11,6 % au trimestre précédent. Toutefois, elle reste dépréciée de 46,0 % par rapport à l'année précédente, avec un euro équivalant à 3 066,9 Fbu au quatrième trimestre 2023, contre 3 086,2 Fbu le trimestre précédent et 2 055,1 Fbu au cours du même trimestre de 2022. En résumé, durant les trois mois du quatrième trimestre 2023, le franc burundais a subi une dépréciation de 0,5 % par rapport au dollar et a apprécié de 0,6 % par rapport à l’euro.",
      image: "assets/Bulletins/notr_conj_2023_4tri.PNG", 
  },
  */
  {
      title: "Note de conjoncture du Burundi, deuxième trimestre 2023",
      link: "/documents/Bulletins/Note-de-conjoncture_T2-2023-1-4.pdf",
      date: new Date("2023-08-01"),
      description: "Une faible augmentation des exportations de 2,4% au cours du 2ième trimestre 2023 en glissement trimestriel et une importante augmentation de 69,7% en glissement annuel",
      image: "assets/Bulletins/notr_conj_2023_2tri.PNG",
  },
  {
      title: "Note de conjoncture du Burundi, deuxième trimestre 2022",
      link: "/documents/Bulletins/Note-de-conjoncture_T2-2022.pdf",
      date: new Date("2022-08-01"),
      description: "Une diminution de la productionindustrielle de 6,6% au cours du 2ième trimestre 2023, en glissement annuel",
      image: "assets/Bulletins/notr_conj_2022_2tri.PNG", 
  },
  {
      title: "Note de conjoncture du Burundi, quatrième trimestre 2020",
      link: "/documents/Bulletins/Note-de-conjoncture_4eme-trim-2020.pdf",
      date: new Date("2020-11-01"),
      description: "L’arrivée de vols internationaux à l’aéroport de Bujumbura connaît une chute de 53,5% au cours du quatrième trimestre de 2020 par rapport au même trimestre de 2019. Pour toute l’année 2020, le nombre d’avions qui ont atteri à l’Aéroport de Bujumbura diminue de 50,5% par rapport àl’année 2019.",
      image: "assets/Bulletins/notr_conj_2020_4tri.PNG",  
  },
  {
      title: "Note de conjoncture du Burundi, quatrième trimestre 2019",
      link: "/documents/Bulletins/Note-de-conjoncture_4eme-trim-2019.pdf",
      date: new Date("2019-12-27"),
      description: "Les recettes fiscales et non fiscales au cours du quatrième trimestre de 2019 augmentent de 24,1% par rapport au même trimestre de 2018.",
      image: "assets/Bulletins/notr_conj_2019_4tri.PNG", 
  },
  {
      title: "Note de conjoncture du Burundi, troisième trimestre 2018",
      link: "/documents/Bulletins/NC2018_t3.pdf",
      date: new Date("2018-11-28"),
      description: "L’arrivée de vols internationaux à l’aéroport de Bujumbura connaît une diminution de 16,7% au cours du trimestre sous analyse par rapport au même trimestre de 2017",
      image: "assets/Bulletins/notr_conj_2018_3tri.PNG", 
  },
  {
      title: "Note de conjoncture du Burundi, deuxième trimestre 2018",
      link: "/documents/Bulletins/Note-de-conjoncture_2eme-trim-2018.pdf",
      date: new Date("2018-08-30"),
      description: "La dépréciation d’un trimestre à l’autre s’estime à 0,4% au cours du deuxième trimestre de 2018 contre 0,7% le trimestreprécédent, témoignant ainsi une atténuation de la dépréciation du franc burundais par rapport au dollar au cours du trimestre sous analyse. ",
      image: "assets/Bulletins/notr_conj_2018_2tri.PNG", 
  },
  {
      title: "Note de conjoncture du Burundi, premier trimestre 2018",
      link: "/documents/Bulletins/Note-de-conjoncture_1er-trim-2018.pdf",
      date: new Date("2018-05-30"),
      description: "En glissement annuel, la dépréciation de la monnaie burundaise est de 4,3% par rapport au dollar américain et de 20,4% par rapport à l’Euro en comparaison avec la même période de 2017",
      image: "assets/Bulletins/notr_conj_2018_1tri.PNG", 
  },
  { 
      title: "Note de conjoncture du Burundi, quatrième trimestre 2017",
      link: "/documents/Bulletins/Note-de-conjoncture-4eme-trimestre-2017.pdf",
      date: new Date("2017-12-28"),
      description: "En glissement annuel, les prix connaissent une augmentation de 6,9% de décembre 2016 à décembre 2017. ",
      image: "assets/Bulletins/notr_conj_2017_4tri.PNG", 
  },
  {
      title: "Note de conjoncture du Burundi, premier trimestre 2017",
      link: "/documents/Bulletins/Note-de-conjoncture_1er-trim-2017.pdf",
      date: new Date("2017-05-30"),
      description: "Les dépenses budgétaires progressent et s’estiment à 324,3 milliards contre 253,4 milliards le trimestre précédent. ",
      image: "assets/Bulletins/notr_conj_2017_1tri.PNG", 
  },
];


function NotesConjoncture() {
  const navigate = useNavigate(); 
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredNotes, setFilteredNotes] = useState(notesConjonctureData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);

    if (year === 'Tous') {
      setFilteredNotes(notesConjonctureData);
      setVisibleCount(4);
    } else {
      const filtered = notesConjonctureData.filter((note) => {
        const noteYear = new Date(note.date).getFullYear();
        return noteYear === parseInt(year);
      });
      setFilteredNotes(filtered);
      setVisibleCount(4);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      secondary: {
        main: '#f50057',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 'bold',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'transform 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.03)',
              boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '50px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Notes de Conjoncture
          </Typography>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1" align="justify" gutterBottom style={{ marginBottom: '20px' }}>
             Cette section présente les Notes de Conjoncture de l'INSBU, qui évaluent périodiquement l'économie burundaise en abordant des thèmes comme la croissance, l'inflation et l'emploi.
          </Typography>
          <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
              variant="outlined"
            >
              <MenuItem value="Tous">Tous les notes</MenuItem>
              {[...new Set(notesConjonctureData.map((note) => new Date(note.date).getFullYear()))]
                .sort((a, b) => b - a)
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

       
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredNotes.slice(0, visibleCount).map((note, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'row', height: '100%' }}>
                   <CardMedia
                       component="img"
                       sx={{ width: 51, height: 80, m: 2,cursor: 'pointer' }}
                       image={note.image}
                       alt={note.title}
                       onClick={() => window.open(note.link, '_blank')} 
                    />
                  <CardContent style={{ flex: 1, padding: '20px' }}>
                    <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                      <a
                        href={note.link}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                       {<DownloadIcon />} {note.title}
                      </a>
                    </Typography>
                    <Typography variant="body2" component="div" gutterBottom style={{ color: '#555', marginBottom: '20px' }}>
                      {note.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

       
          {visibleCount < filteredNotes.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Notes
            </Button>
          )}
          <br />
          <br />
          <Typography
          variant="body1"
          align="justify"
          paragraph
          style={{ marginBottom: '24px', lineHeight: 1.6 }}
          >
            <strong>Note :</strong> Les Notes de Conjoncture sont publiées trimestriellement, généralement <strong>45 jours</strong> après la clôture de chaque trimestre. Les dates prévues pour la publication sont les suivantes :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 février</strong> - Publication des données pour le quatrième trimestre</li>
              <li><strong>15 mai</strong> - Publication des données pour le premier trimestre</li>
              <li><strong>15 août</strong> - Publication des données pour le deuxième trimestre</li>
              <li><strong>15 novembre</strong> - Publication des données pour le troisième trimestre</li>
            </ul>
          </Typography>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button 
              onClick={() => navigate('/bulletin')} 
              style={{
                marginTop: '5px',
                backgroundColor: '#388E3C', 
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des bulletins
            </Button>
          </Box>
        </Container>
        <br />
        <br />
      </div>
      <Footer />
    </ThemeProvider>
  );
}

export default NotesConjoncture;